'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function HubSpotPageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const trackPageView = () => {
      if (window._hsq) {
        window._hsq.push(['setPath', pathname]);
        window._hsq.push(['trackPageView']);
      }
    };

    // Try immediately in case _hsq is already available
    if (window._hsq) {
      trackPageView();
      return;
    }

    // Otherwise, poll for _hsq availability (up to 10 seconds)
    const checkInterval = setInterval(() => {
      if (window._hsq) {
        trackPageView();
        clearInterval(checkInterval);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeout);
    };
  }, [pathname]);

  return null;
}
